var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(-1381 -1020)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    opacity: 0.249,
    transform: "translate(1381 1020)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.368 0H2.862A2.86 2.86 0 0 0 0 2.86v15.506a2.86 2.86 0 0 0 2.86 2.86h7.65l.013-7.585H8.552a.465.465 0 0 1-.465-.463l-.009-2.445a.465.465 0 0 1 .465-.467h1.967V7.9a3.86 3.86 0 0 1 4.12-4.235h2.007a.465.465 0 0 1 .465.465V6.2a.465.465 0 0 1-.465.465h-1.231c-1.33 0-1.588.632-1.588 1.56v2.045h2.923a.465.465 0 0 1 .462.52l-.29 2.445a.465.465 0 0 1-.462.41h-2.62l-.013 7.585h4.55a2.86 2.86 0 0 0 2.86-2.86V2.86A2.86 2.86 0 0 0 18.368 0z",
    transform: "translate(1391.998 1031)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.93d2019cff25502b261b96889360e233.svg";
export { ForwardRef as ReactComponent };